import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import KeyRoundedIcon from '@mui/icons-material/KeyRounded';
import SpeedRoundedIcon from '@mui/icons-material/SpeedRounded';
import SensorDoorRoundedIcon from '@mui/icons-material/SensorDoorRounded';
import AcUnitRoundedIcon from '@mui/icons-material/AcUnitRounded';
import styles from "./VehicleStateIcons.module.scss";
import { Button, Tooltip } from "@mui/material";
import openDoor from "../../../assets/abertura-da-porta-aberta.png";

export const VehicleStateIcons = ({
  numberOfEvents,
  driverAwareness,
  ignition,
  speed,
  thermoKing,
  isAlarmActived,
  door,
}) => {
  return (
    <div className={styles.boxIcons}>
      <Tooltip
        title={
          driverAwareness === 0 && isAlarmActived > 0
            ? "Botão de Ciência Não Pressionado"
            : (numberOfEvents > 0 && isAlarmActived === 0) ||
              (driverAwareness === 1 && isAlarmActived > 0)
              ? "Motorista Ciente"
              : "Sem Alarmes para Ciência"
        }
      >
        <WarningAmberRoundedIcon
          className={`${styles.driverAwarenessIcon} ${driverAwareness === 0 && isAlarmActived > 0
              ? styles.driverNonAware
              : (numberOfEvents > 0 && isAlarmActived === 0) ||
                (driverAwareness === 1 && isAlarmActived > 0)
                ? styles.driverAware
                : styles.driverDontNeedToBeAware
            }`}
        />
      </Tooltip>
      <Tooltip
        title={
          thermoKing === "OFF"
            ? "Climatização Desligada"
            : thermoKing === "ON"
              ? "Climatização Ligada"
              : "Climatização Desligada com alarme"
        }
      >
        <AcUnitRoundedIcon
          className={`${styles.thermoKingIcon} ${thermoKing === "OFF"
              ? styles.thermoKingOFF
              : thermoKing === "ON"
                ? styles.thermoKingON
                : styles.thermoKingOFFatention
            }`}
        />
      </Tooltip>
      <Tooltip title={ignition ? "Ignição Ligada" : "Ignição Desligada"}>
        <KeyRoundedIcon
          className={`${styles.ignitionIcon} ${ignition ? styles.ignitionOn : styles.ignitionOff
            }`}
        />
      </Tooltip>
      <Tooltip title={door ? "Porta Fechada" : "Porta Aberta"}>
        {door ? (
          <SensorDoorRoundedIcon
            className={`${styles.doorIcon} ${door ? styles.doorCloseIcon : styles.doorOpenIcon
              }`}
          />
        ) : (
          <img
            src={openDoor}
            alt="Ícone"
            style={{
              height: "18px",
              width: "18px",
            }}
          />
        )}
      </Tooltip>
      <Button
        className={styles.speedContainer}
        variant="text"
        startIcon={<SpeedRoundedIcon className={styles.speedIcon} />}
      >
        <span className={styles.speedText}>{speed + " km/h"}</span>
      </Button>
    </div>
  );
};
